export default __webpack_public_path__ + "static/media/pricing_art_2.53431cb8.png";